import {createRouter, createWebHistory} from "@ionic/vue-router";
import Login from "../pages/Login.vue";
import Register from "../pages/Register.vue";
import Dashboard from "../pages/Dashboard.vue";
import store from "../store/index";
import Products from "@/pages/Products";
import reports from "@/pages/reports";
import totalIncomeReport from "@/pages/incomeReport";

import customerRoutes from "@/router/customerRoutes";
import warehouseRoutes from "@/router/warehouseRoutes";
import customerCarRoutes from "@/router/customerCarRoutes";
import orderRoutes from "@/router/orderRoutes";
import adminRoutes from "@/router/adminRoutes";
import carsRoutes from "@/router/carsRoutes";
import forgotPass from "@/pages/forgotPass";
import servicesList from "@/pages/allServiceList";
import servicesManage from "@/pages/servicesManage";


import wastageRoute from "@/router/wastageRoute";
import shopRoutes from "@/router/shopRoutes";
import reportOil from "@/pages/reportOil"
import productProfit from "@/pages/report/productProfitReport"
import serviceProfit from "@/pages/report/serviceProfitReport"
import wastageProfit from "@/pages/report/wastageProfitReport"
import userReport from "@/pages/report/userReport"
import ali from "@/pages/ali";
import AddressRoute from "@/router/AddressRoute";
import Logout from "@/pages/Logout";
import UserNotFound from "@/pages/error/UserNotFound";
import autoBarcodeScan from "@/pages/autoBarcodeScan";
import scanOrderQrcode from "@/pages/scanOrderQrcode";
import adminReport from "@/pages/report/adminReport";
import messageRoutes from "@/router/messageRoutes";
import missionRoutes from "@/router/missionRoutes";
import incomingRoutes from "@/router/incomingRoutes";
import commissionRoutes from "@/router/commissionRoutes";
import catalogList from "../pages/catalogList";
import catalogAdd from "../pages/catalogAdd";
import catalogEdit from "../pages/catalogEdit";

const routes = [
  ...warehouseRoutes,
  ...customerRoutes,
  ...customerCarRoutes,
  ...orderRoutes,
  ...adminRoutes,
  ...wastageRoute,
  ...carsRoutes,
  ...shopRoutes,
  ...AddressRoute,
  ...messageRoutes,
  ...missionRoutes,
  ...incomingRoutes,
  ...commissionRoutes,
  {
    path: "/",
    component: Dashboard,
    meta: {requiredAuth: true},
  },
  {
    path: "/Ali",
    component: ali,
    meta: {requiredAuth: true},
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/Register",
    component: Register,
  },
  {
    path: "/Logout",
    component: Logout,
  },
  {
    path: "/forgotPassword",
    component: forgotPass,
  },
  {
    path: "/Dashboard",
    component: Dashboard,
    meta: {requiredAuth: true},
  },
  {
    path: "/Products",
    component: Products,
    meta: {requiredAuth: true},
  },
  {
    path: "/Reports",
    component: reports,
    meta: {requiredAuth: true},
  },
  {
    path: "/Service/Manage",
    component: servicesList,
    meta: {requiredAuth: true},
  },
  {
    path: "/services/Manage",
    component: servicesManage,
    meta: {requiredAuth: true},
  },
  {
    path: "/OrderOil/Report",
    component: reportOil,
    meta: {requiredAuth: true},
  },
  {
    path: "/Report/ProductProfit",
    component: productProfit,
    meta: {requiredAuth: true},
  },
  {
    path: "/Report/ServiceProfit",
    component: serviceProfit,
    meta: {requiredAuth: true},
  },
  {
    path: "/Report/wastageProfit",
    component: wastageProfit,
    meta: {requiredAuth: true},
  },
  {
    path: "/Report/user",
    component: userReport,
    meta: {requiredAuth: true},
  },
  {
    path: "/Report/admin",
    component: adminReport,
    meta: {requiredAuth: true},
  },
  {
    path: "/totalIncomeReport",
    component: totalIncomeReport,
    meta: {requiredAuth: true},
  },
  {
    path: "/Error/UserNotFound",
    component: UserNotFound,
    meta: {requiredAuth: true,noPlanNeed:true},
  },
  {
    path: "/Auto/BarcodeScan",
    component: autoBarcodeScan,
    meta: {requiredAuth: true},
  },
  {
    path: "/scanOrderQrcode",
    component: scanOrderQrcode,
    meta: {requiredAuth: true},
  },
  {
    path: "/Catalog/List",
    component: catalogList,
    meta: {requiredAuth: true},
  },
  {
    path: "/Catalog/Add",
    component: catalogAdd,
    meta: {requiredAuth: true},
  },
  {
    path: "/Catalog/Edit/:id",
    component: catalogEdit,
    meta: {requiredAuth: true},
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  duplicateNavigationPolicy:'reload'
});

async function guard(to, from, next, authData)
{
  if (to.meta && to.meta.requiredAuth)
  {
    // return next();
    if (authData  && authData.userId  && authData.userId.length)
    {
      await store.dispatch("auth/getCurrentUserInfo");
      const user = store.getters["auth/getUserInfo"];
      if (user)
      {
        store.dispatch('shop/setCartCount',(user.cart_count?user.cart_count:0))
      }
      if (!user)
        return next({path: "/Error/UserNotFound"});
      return next();

      // if (!user.auto_service.app_plan_expire_date)
      //   user.auto_service.app_plan_expire_date = new Date();
      // const expireDate = new Date(user.auto_service.app_plan_expire_date);
      // if (expireDate.getTime()>(new Date().getTime()+1000))
      //   return next();
      //
      // //only routes that doesnt need subscription plan
      // if (to.meta.noPlanNeed)
      //   return next();
      //
      // return next({path: "/Plans/List"});
    }
    return next({path: "/login"});
  }
  else
  {
    // if (authData  && authData.userId  && authData.userId.length)
    // {
    //   return next({path: "/dashboard"});
    // }
    return next();
  }
}

router.beforeEach((to, from, next) =>
{
  let authData = store.getters["auth/getAuthData"];
  if (!authData.userId || !authData.userId.length)
  {
    store.dispatch("auth/loadStorageTokens").then(
      () =>
      {
        authData = store.getters["auth/getAuthData"];
        return guard(to, from, next, authData);
      },
      (error) =>
      {
        console.log(error);
        return guard(to, from, next, authData);
      }
    );
  }
  else
  {
    return guard(to, from, next, authData);
  }
});

export default router;